<template>

  <!-- Basic area chart -->
  <div :class="'card '+data.class">
    <div class="card-body">
      <div class="d-flex">
        <h3 class="font-weight-semibold mb-0">{{data.value}}</h3>
        <div class="list-icons ml-auto">
                  <a class="list-icons-item" data-action="reload"></a>
                </div>
              </div>

              <div>
        {{data.label}}
        <div class="text-muted opacity-75">{{data.legend}}</div>
      </div>
    </div>
    <div :id="'chart_'+data.id"></div>
  </div>
  <!-- /basic area chart -->

</template>

<script>

var _areaChartWidget = function(element, chartHeight, color) {
  if (typeof d3 == 'undefined') {
     console.warn('Warning - d3.min.js is not loaded.');
     return;
  }

  // Initialize chart only if element exsists in the DOM
  if(element) {


     // Basic setup
     // ------------------------------

     // Define main variables
     var d3Container = d3.select(element),
         margin = {top: 0, right: 0, bottom: 0, left: 0},
         width = d3Container.node().getBoundingClientRect().width - margin.left - margin.right,
         height = chartHeight - margin.top - margin.bottom;

     // Date and time format
     var parseDate = d3.time.format('%Y-%m-%d').parse;


     // Create SVG
     // ------------------------------

     // Container
     var container = d3Container.append('svg');

     // SVG element
     var svg = container
         .attr('width', width + margin.left + margin.right)
         .attr('height', height + margin.top + margin.bottom)
         .append("g")
             .attr("transform", "translate(" + margin.left + "," + margin.top + ")");


     // Construct chart layout
     // ------------------------------

     // Area
     var area = d3.svg.area()
         .x(function(d) { return x(d.date); })
         .y0(height)
         .y1(function(d) { return y(d.value); })
         .interpolate('monotone');


     // Construct scales
     // ------------------------------

     // Horizontal
     var x = d3.time.scale().range([0, width ]);

     // Vertical
     var y = d3.scale.linear().range([height, 0]);


     // Load data
     // ------------------------------

     d3.json("/demo_data/dashboard/monthly_sales.json", function (error, data) {

         // Show what's wrong if error
         if (error) return console.error(error);

         // Pull out values
         data.forEach(function (d) {
             d.date = parseDate(d.date);
             d.value = +d.value;
         });

         // Get the maximum value in the given array
         var maxY = d3.max(data, function(d) { return d.value; });

         // Reset start data for animation
         var startData = data.map(function(datum) {
             return {
                 date: datum.date,
                 value: 0
             };
         });


         // Set input domains
         // ------------------------------

         // Horizontal
         x.domain(d3.extent(data, function(d, i) { return d.date; }));

         // Vertical
         y.domain([0, d3.max( data, function(d) { return d.value; })]);

         //
         // Append chart elements
         //

         // Add area path
         svg.append("path")
             .datum(data)
             .attr("class", "d3-area")
             .style('fill', color)
             .attr("d", area)
             .transition() // begin animation
                 .duration(1000)
                 .attrTween('d', function() {
                     var interpolator = d3.interpolateArray(startData, data);
                     return function (t) {
                         return area(interpolator (t));
                     };
                 });


         // Resize chart
         // ------------------------------

         // Call function on window resize
         $(window).on('resize', messagesAreaResize);

         // Call function on sidebar width change
         $(document).on('click', '.sidebar-control', messagesAreaResize);

         // Resize function
         //
         // Since D3 doesn't support SVG resize by default,
         // we need to manually specify parts of the graph that need to
         // be updated on window resize
         function messagesAreaResize() {

             // Layout variables
             width = d3Container.node().getBoundingClientRect().width - margin.left - margin.right;


             // Layout
             // -------------------------

             // Main svg width
             container.attr("width", width + margin.left + margin.right);

             // Width of appended group
             svg.attr("width", width + margin.left + margin.right);

             // Horizontal range
             x.range([0, width]);


             // Chart elements
             // -------------------------

             // Area path
             svg.selectAll('.d3-area').datum( data ).attr("d", area);
         }
     });
  }
  };

  // Simple bar charts
  var _barChartWidget = function(element, barQty, height, animate, easing, duration, delay, color, tooltip) {
   if (typeof d3 == 'undefined') {
       console.warn('Warning - d3.min.js is not loaded.');
       return;
   }

   // Initialize chart only if element exsists in the DOM
   if(element) {


       // Basic setup
       // ------------------------------

       // Add data set
       var bardata = [];
       for (var i=0; i < barQty; i++) {
           bardata.push(Math.round(Math.random() * 10) + 10);
       }

       // Main variables
       var d3Container = d3.select(element),
           width = d3Container.node().getBoundingClientRect().width;



       // Construct scales
       // ------------------------------

       // Horizontal
       var x = d3.scale.ordinal()
           .rangeBands([0, width], 0.3);

       // Vertical
       var y = d3.scale.linear()
           .range([0, height]);



       // Set input domains
       // ------------------------------

       // Horizontal
       x.domain(d3.range(0, bardata.length));

       // Vertical
       y.domain([0, d3.max(bardata)]);



       // Create chart
       // ------------------------------

       // Add svg element
       var container = d3Container.append('svg');

       // Add SVG group
       var svg = container
           .attr('width', width)
           .attr('height', height)
           .append('g');



       //
       // Append chart elements
       //

       // Bars
       var bars = svg.selectAll('rect')
           .data(bardata)
           .enter()
           .append('rect')
               .attr('class', 'd3-random-bars')
               .attr('width', x.rangeBand())
               .attr('x', function(d,i) {
                   return x(i);
               })
               .style('fill', color);



       // Tooltip
       // ------------------------------

       // Initiate
       var tip = d3.tip()
           .attr('class', 'd3-tip')
           .offset([-10, 0]);

       // Show and hide
       if(tooltip == "hours" || tooltip == "goal" || tooltip == "members") {
           bars.call(tip)
               .on('mouseover', tip.show)
               .on('mouseout', tip.hide);
       }

       // Daily meetings tooltip content
       if(tooltip == "hours") {
           tip.html(function (d, i) {
               return "<div class='text-center'>" +
                       "<h6 class='mb-0'>" + d + "</h6>" +
                       "<span class='font-size-sm'>meetings</span>" +
                       "<div class='font-size-sm'>" + i + ":00" + "</div>" +
                   "</div>";
           });
       }

       // Statements tooltip content
       if(tooltip == "goal") {
           tip.html(function (d, i) {
               return "<div class='text-center'>" +
                       "<h6 class='mb-0'>" + d + "</h6>" +
                       "<span class='font-size-sm'>statements</span>" +
                       "<div class='font-size-sm'>" + i + ":00" + "</div>" +
                   "</div>";
           });
       }

       // Online members tooltip content
       if(tooltip == "members") {
           tip.html(function (d, i) {
               return "<div class='text-center'>" +
                       "<h6 class='mb-0'>" + d + "0" + "</h6>" +
                       "<span class='font-size-sm'>members</span>" +
                       "<div class='font-size-sm'>" + i + ":00" + "</div>" +
                   "</div>";
           });
       }



       // Bar loading animation
       // ------------------------------

       // Choose between animated or static
       if(animate) {
           withAnimation();
       } else {
           withoutAnimation();
       }

       // Animate on load
       function withAnimation() {
           bars
               .attr('height', 0)
               .attr('y', height)
               .transition()
                   .attr('height', function(d) {
                       return y(d);
                   })
                   .attr('y', function(d) {
                       return height - y(d);
                   })
                   .delay(function(d, i) {
                       return i * delay;
                   })
                   .duration(duration)
                   .ease(easing);
       }

       // Load without animateion
       function withoutAnimation() {
           bars
               .attr('height', function(d) {
                   return y(d);
               })
               .attr('y', function(d) {
                   return height - y(d);
               });
       }



       // Resize chart
       // ------------------------------

       // Call function on window resize
       $(window).on('resize', barsResize);

       // Call function on sidebar width change
       $(document).on('click', '.sidebar-control', barsResize);

       // Resize function
       //
       // Since D3 doesn't support SVG resize by default,
       // we need to manually specify parts of the graph that need to
       // be updated on window resize
       function barsResize() {

           // Layout variables
           width = d3Container.node().getBoundingClientRect().width;


           // Layout
           // -------------------------

           // Main svg width
           container.attr("width", width);

           // Width of appended group
           svg.attr("width", width);

           // Horizontal range
           x.rangeBands([0, width], 0.3);


           // Chart elements
           // -------------------------

           // Bars
           svg.selectAll('.d3-random-bars')
               .attr('width', x.rangeBand())
               .attr('x', function(d,i) {
                   return x(i);
               });
       }
   }
  };

  // Simple line chart
  var _lineChartWidget = function(element, chartHeight, lineColor, pathColor, pointerLineColor, pointerBgColor) {
   if (typeof d3 == 'undefined') {
       console.warn('Warning - d3.min.js is not loaded.');
       return;
   }

   // Initialize chart only if element exsists in the DOM
   if(element) {


       // Basic setup
       // ------------------------------

       // Add data set
       var dataset = [
           {
               "date": "04/13/14",
               "alpha": "60"
           }, {
               "date": "04/14/14",
               "alpha": "35"
           }, {
               "date": "04/15/14",
               "alpha": "65"
           }, {
               "date": "04/16/14",
               "alpha": "50"
           }, {
               "date": "04/17/14",
               "alpha": "65"
           }, {
               "date": "04/18/14",
               "alpha": "20"
           }, {
               "date": "04/19/14",
               "alpha": "60"
           }
       ];

       // Main variables
       var d3Container = d3.select(element),
           margin = {top: 0, right: 0, bottom: 0, left: 0},
           width = d3Container.node().getBoundingClientRect().width - margin.left - margin.right,
           height = chartHeight - margin.top - margin.bottom,
           padding = 20;

       // Format date
       var parseDate = d3.time.format("%m/%d/%y").parse,
           formatDate = d3.time.format("%a, %B %e");


       // Add tooltip
       // ------------------------------

       var tooltip = d3.tip()
           .attr('class', 'd3-tip')
           .html(function (d) {
               return "<ul class='list-unstyled mb-1'>" +
                   "<li>" + "<div class='font-size-base my-1'><i class='icon-check2 mr-2'></i>" + formatDate(d.date) + "</div>" + "</li>" +
                   "<li>" + "Sales: &nbsp;" + "<span class='font-weight-semibold float-right'>" + d.alpha + "</span>" + "</li>" +
                   "<li>" + "Revenue: &nbsp; " + "<span class='font-weight-semibold float-right'>" + "$" + (d.alpha * 25).toFixed(2) + "</span>" + "</li>" +
               "</ul>";
           });


       // Create chart
       // ------------------------------

       // Add svg element
       var container = d3Container.append('svg');

       // Add SVG group
       var svg = container
               .attr('width', width + margin.left + margin.right)
               .attr('height', height + margin.top + margin.bottom)
               .append("g")
                   .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
                   .call(tooltip);


       // Load data
       // ------------------------------

       dataset.forEach(function (d) {
           d.date = parseDate(d.date);
           d.alpha = +d.alpha;
       });


       // Construct scales
       // ------------------------------

       // Horizontal
       var x = d3.time.scale()
           .range([padding, width - padding]);

       // Vertical
       var y = d3.scale.linear()
           .range([height, 5]);


       // Set input domains
       // ------------------------------

       // Horizontal
       x.domain(d3.extent(dataset, function (d) {
           return d.date;
       }));

       // Vertical
       y.domain([0, d3.max(dataset, function (d) {
           return Math.max(d.alpha);
       })]);


       // Construct chart layout
       // ------------------------------

       // Line
       var line = d3.svg.line()
           .x(function(d) {
               return x(d.date);
           })
           .y(function(d) {
               return y(d.alpha);
           });


       //
       // Append chart elements
       //

       // Add mask for animation
       // ------------------------------

       // Add clip path
       var clip = svg.append("defs")
           .append("clipPath")
           .attr("id", "clip-line-small");

       // Add clip shape
       var clipRect = clip.append("rect")
           .attr('class', 'clip')
           .attr("width", 0)
           .attr("height", height);

       // Animate mask
       clipRect
             .transition()
                 .duration(1000)
                 .ease('linear')
                 .attr("width", width);


       // Line
       // ------------------------------

       // Path
       var path = svg.append('path')
           .attr({
               'd': line(dataset),
               "clip-path": "url(#clip-line-small)",
               'class': 'd3-line d3-line-medium'
           })
           .style('stroke', lineColor);

       // Animate path
       svg.select('.line-tickets')
           .transition()
               .duration(1000)
               .ease('linear');


       // Add vertical guide lines
       // ------------------------------

       // Bind data
       var guide = svg.append('g')
           .selectAll('.d3-line-guides-group')
           .data(dataset);

       // Append lines
       guide
           .enter()
           .append('line')
               .attr('class', 'd3-line-guides')
               .attr('x1', function (d, i) {
                   return x(d.date);
               })
               .attr('y1', function (d, i) {
                   return height;
               })
               .attr('x2', function (d, i) {
                   return x(d.date);
               })
               .attr('y2', function (d, i) {
                   return height;
               })
               .style('stroke', pathColor)
               .style('stroke-dasharray', '4,2')
               .style('shape-rendering', 'crispEdges');

       // Animate guide lines
       guide
           .transition()
               .duration(1000)
               .delay(function(d, i) { return i * 150; })
               .attr('y2', function (d, i) {
                   return y(d.alpha);
               });


       // Alpha app points
       // ------------------------------

       // Add points
       var points = svg.insert('g')
           .selectAll('.d3-line-circle')
           .data(dataset)
           .enter()
           .append('circle')
               .attr('class', 'd3-line-circle d3-line-circle-medium')
               .attr("cx", line.x())
               .attr("cy", line.y())
               .attr("r", 3)
               .style({
                   'stroke': pointerLineColor,
                   'fill': pointerBgColor
               });

       // Animate points on page load
       points
           .style('opacity', 0)
           .transition()
               .duration(250)
               .ease('linear')
               .delay(1000)
               .style('opacity', 1);

       // Add user interaction
       points
           .on("mouseover", function (d) {
               tooltip.offset([-10, 0]).show(d);

               // Animate circle radius
               d3.select(this).transition().duration(250).attr('r', 4);
           })

           // Hide tooltip
           .on("mouseout", function (d) {
               tooltip.hide(d);

               // Animate circle radius
               d3.select(this).transition().duration(250).attr('r', 3);
           });

       // Change tooltip direction of first point
       d3.select(points[0][0])
           .on("mouseover", function (d) {
               tooltip.offset([0, 10]).direction('e').show(d);

               // Animate circle radius
               d3.select(this).transition().duration(250).attr('r', 4);
           })
           .on("mouseout", function (d) {
               tooltip.direction('n').hide(d);

               // Animate circle radius
               d3.select(this).transition().duration(250).attr('r', 3);
           });

       // Change tooltip direction of last point
       d3.select(points[0][points.size() - 1])
           .on("mouseover", function (d) {
               tooltip.offset([0, -10]).direction('w').show(d);

               // Animate circle radius
               d3.select(this).transition().duration(250).attr('r', 4);
           })
           .on("mouseout", function (d) {
               tooltip.direction('n').hide(d);

               // Animate circle radius
               d3.select(this).transition().duration(250).attr('r', 3);
           });


       // Resize chart
       // ------------------------------

       // Call function on window resize
       $(window).on('resize', lineChartResize);

       // Call function on sidebar width change
       $(document).on('click', '.sidebar-control', lineChartResize);

       // Resize function
       //
       // Since D3 doesn't support SVG resize by default,
       // we need to manually specify parts of the graph that need to
       // be updated on window resize
       function lineChartResize() {

           // Layout variables
           width = d3Container.node().getBoundingClientRect().width - margin.left - margin.right;


           // Layout
           // -------------------------

           // Main svg width
           container.attr("width", width + margin.left + margin.right);

           // Width of appended group
           svg.attr("width", width + margin.left + margin.right);

           // Horizontal range
           x.range([padding, width - padding]);


           // Chart elements
           // -------------------------

           // Mask
           clipRect.attr("width", width);

           // Line path
           svg.selectAll('.d3-line').attr("d", line(dataset));

           // Circles
           svg.selectAll('.d3-line-circle').attr("cx", line.x());

           // Guide lines
           svg.selectAll('.d3-line-guides')
               .attr('x1', function (d, i) {
                   return x(d.date);
               })
               .attr('x2', function (d, i) {
                   return x(d.date);
               });
       }
   }
  };

export default {
  name: 'StatBlock',
  props: {
    data: Object
  },
  created: function() {
    console.log("created")
  },
  mounted: function() {
    console.log("mounted");
    switch(this.data.type) {
      case "areaChart":
        _areaChartWidget("#chart_"+this.data.id, 50, 'rgba(255,255,255,0.75)');
        break;
      case "barChart":
        _barChartWidget("#chart_"+this.data.id, 24, 50, true, "elastic", 1200, 50, "rgba(255,255,255,0.75)", "members");
        break;
      case "lineChart":
        _lineChartWidget("#chart_"+this.data.id, 50, '#fff', 'rgba(255,255,255,0.5)', '#fff', '#29B6F6');
        break;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>
